'use strict';

var util = require('./util'),
    imagesLoaded = require('imagesloaded');

var dialog = {
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function (params) {
        const self = this;
        var $target, id;

        import(/* webpackChunkName: "lodash" */ 'lodash').then((_) => {
            if (_.isString(params.target)) {
                if (params.target.charAt(0) === '#') {
                    $target = $(params.target);
                } else {
                    $target = $('#' + params.target);
                }
            } else if (params.target instanceof jQuery) {
                $target = params.target;
            } else {
                $target = $('#dialog-container');
            }

            // if no element found, create one
            if ($target.length === 0) {
                id = 'dialog-container';
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }

            // create the dialog
            this.$container = $target;
            this.$container.dialog(_.merge({}, this.settings, params.options || {}, {
                // merging default behavior from open/close internal callbacks with the one from custom callbacks
                // so that both callbacks would be triggered
                open() {
                    if (typeof self.settings.open === 'function') {
                        self.settings.open();
                    }
                    if (typeof params.options != 'undefined' && typeof params.options.open === 'function') {
                        params.options.open();
                    }
                },
                close() {
                    if (typeof self.settings.close === 'function') {
                        self.settings.close();
                    }
                    if (typeof params.options != 'undefined' && typeof params.options.close === 'function') {
                        params.options.close();
                    }
                }
            }));
            this.replace(params);
        });
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        // close any open dialog
        this.close();
        this.create(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params) {
        var content, position, callback;

        if (!this.$container) { return; }
        content = params.content || params.html;
        if (!content) { return; }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', function () {
            this.$container.dialog('option', 'position', position);
        }.bind(this));

        callback = (typeof params.callback === 'function') ? params.callback : function () {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            var that = this;
            $.ajax({
                type: 'GET',
                url: params.url,
                data: params.data,
                success: function(response) {
                    params.content = response;
                    that.openWithContent(params);
                }
            })
                .done(function() {
                // Initilization
                    const $dialogSelectFields = $(params.select2Init);
                    if ($dialogSelectFields && $dialogSelectFields.length) {
                        $dialogSelectFields.select2();
                    }
                });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        width: 'auto',
        maxWidth: '800',
        open: function () {
            // disabling body scroll (works on iOS devices too)
            $('body:not(:has(.ui-dialog--quickview))').addClass('modal-open stop-scroll');

            // apply select2 plugin to new select fields inside the opened dialog layout
            const $dialogSelectFields = $('#dialog-container select');

            if ($dialogSelectFields.length) {
                $dialogSelectFields.select2();
            }
            $('.ui-dialog').animate({scrollTop: 0}, 0);
        },
        close: function () {
            $('body').removeClass('modal-open stop-scroll');
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

module.exports = dialog;
